export default {
  'consumption.co2': '二酸化炭素(CO₂)排出量',
  'consumption.energy': '電力消費率(電気自動車/ハイブリッド車）（国土交通省審査値)',
  'consumption.fuel': '燃料消費率(国土交通省審査値)　WLTCモード',
  'footnotes.local': '',
  'footnotes.wltp':
    'WLTCモードに基づく燃費消費率となります。WLTCモードは、市街地、郊外、高速道路の各走行モードを平均的な使用時間配分で構成した国際的な走行モードです。 市街地モードは、信号や渋滞等の影響を受ける比較的低速な走行を想定し、郊外モードは、信号や渋滞等の影響をあまり受けない走行を想定、高速道路モードは、高速道路等での走行を想定しています。',
  'footnotes.nedc': '',
  'footnotes.emissions.appendix': '',
  'search.input.label': '検索',
  'search.result.buy-online': 'オンラインで購入する',
  'search.results': '0件 | {count} 件 | {count} 件',
  'search.results.count': '{count} 件',
  'search.results.backup': '完全に一致するものは見つかりませんでした。関連ページをご覧ください。',
  'search.results.none.summary':
    '検索されたキーワードに該当するものはありませんでした。キーワードを変更して再度検索してください。',
  'search.show-more': 'もっと見る',
  'search.unavailable': '現在、検索はご利用いただけません',
  'search.result.new': 'New',

  'support.check': '誤字脱字を確認するか、別の用語で再試行してください。',
  'support.no.results': 'この検索用語には検索結果がありません。',
  'support.no.results.term': '結果が見つかりません',
  'support.chat': '検索対象が見つかりませんが？オンラインチャットサポー',
  'support.chat.with.us': 'トをご利用ください',

  'input.placeholder': '検索',

  'suggestions.all_search_results': 'すべての検索結果',
  'suggestions.all_search_results_for': 'すべての結果を表示',
  'suggestions.in': '内で',

  all: '全て',
  didyoumean: '이것을 찾으시나요',
  UCOS: '認定中古車検索',
  PASSENGER_CARS: 'Passenger cars',
  VANS: 'Vans',
  NCOS: 'オンラインショールーム',
  VIDEO: '動画',
  DEALER_LOCATOR: 'ディーラー検索',
  CONFIGURATOR: '見積シミュレーション',
  TEST_DRIVE: '試乗予約',
  VEHICLE_SEARCH: '認定中古車検索',
  COLLECT: '純正アクセサリー',
  CONNECT: 'Mercedes me Store',
  ACCESSORIES: 'カーアクセサリー',

  'search.result.consumption': '燃費',
  'watch.video': '動画をご覧ください',
  'input.recently': '最近検索済み',
  'input.help.title': '検索内容は？',
  'input.help.text':
    '車両タイプ、モデル、設定コードを使用して検索するか、アクセサリー、その他の製品及び情報を検索します',

  'search.result.grid': 'グリル',
  'search.result.list': 'リスト',

  'search.results.offer': '人気のオファー "{query}":',
};
